import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'hash', // hash or history
    base: process.env.BASE_URL,
    routes: [ //对比
        // {
        //     path: '/',
        //     name: 'catalogue',
        //     component: () => import('@/views/catalogue.vue')
        // },
        {
            path: '/',
            name: 'layout',
            redirect: "/home",  //重定向到第一个子路由
            component: () => import('@/views/layout'),
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: Home,
                    meta:{title:'首页'}
                },
                {
                    path: '/Register',
                    name: 'Register',
                    component: () => import('@/views/Register.vue'),
                    meta:{title:'注册'}
                },
                {
                    path: '/refresh',
                    name: 'refresh',
                    component: () => import('@/views/refresh/index'),
                    hidden: true
                },
                {
                    path: '/SearchResult',
                    name: 'SearchResult',
                    component: () => import('@/views/SearchResult.vue'),
                    meta:{title:'搜索'}
                },
                {
                    path: '/About',
                    name: 'About',
                    component: () => import('@/views/about/About.vue'),
                    meta:{title:'关于我们'}
                },
                {
                    path: '/Brand',
                    name: 'Brand',
                    component: () => import('@/views/brand/Brand.vue'),
                    meta:{title:'品牌中心'}
                },
                {
                    path: '/BrandDetail',
                    name: 'BrandDetail',
                    component: () => import('@/views/brand/BrandDetail.vue'),
                    meta:{title:'品牌中心-详情'}
                },
                {
                    path: '/TechInfo',
                    name: 'TechInfo',
                    component: () => import('@/views/TechInfo.vue'),
                    meta:{title:'技术信息'}
                },
                {
                    path: '/TechInfoDet',
                    name: 'TechInfoDet',
                    component: () => import('@/views/TechInfoDet.vue'),
                    meta:{title:'技术信息'}
                },
                {
                    path: '/ProductInfo',
                    name: 'ProductInfo',
                    component: () => import('@/views/product/ProductInfo.vue'),
                    meta:{title:'产品资讯'}
                },
                {
                    path: '/ProductInfoDetail',
                    name: 'ProductInfoDetail',
                    component: () => import('@/views/product/ProductInfoDetail.vue'),
                    meta:{title:'产品资讯-详情'}
                },
                {
                    path: '/ProductDetail',
                    name: 'ProductDetail',
                    component: () => import('@/views/product/ProductDetail.vue'),
                    meta:{title:'产品-详情'}
                },
                {
                    path: '/SearchProductDetail',
                    name: 'SearchProductDetail',
                    component: () => import('@/views/product/SearchProductDetail.vue'),
                    meta:{title:'产品-详情'}
                },
                {
                    path: '/MSDSCOA',
                    name: 'MSDSCOA',
                    component: () => import('@/views/MSDSCOA.vue'),
                    meta:{title:'MSDA/COA'}
                },
                {
                    path: '/News',
                    name: 'News',
                    component: () => import('@/views/news/News.vue'),
                    meta:{title:'新闻中心'}
                },
                {
                    path: '/NewsDetail',
                    name: 'NewsDetail',
                    component: () => import('@/views/news/NewsDetail.vue'),
                    meta:{title:'新闻-详情'}
                },
                {
                    path: '/integralMall',
                    name: 'integralMall',
                    component: () => import('@/views/integralMall/Mall.vue'),
                    meta:{title:'积分商城'}
                },
                {
                    path: '/IntegralMall/Detail',
                    name: 'IntegralMallDetail',
                    component: () => import('@/views/integralMall/Detail.vue'),
                    meta:{title:'积分商城-详情'}
                },
                {
                    path: '/IntegralMall/Exchange',
                    name: 'IntegralMallExchange',
                    component: () => import('@/views/integralMall/Exchange.vue'),
                    meta:{title:'积分兑换'}
                },
                {
                    path: '/IntegralMall/Result',
                    name: 'IntegralMallResult',
                    component: () => import('@/views/integralMall/Result.vue'),
                    meta:{title:'积分兑换-结果'}
                },
                {
                    path: '/ContactUs',
                    name: 'ContactUs',
                    component: () => import('@/views/ContactUs.vue'),
                    meta:{title:'联系我们'}
                },
                {
                    path: '/Cart',
                    name: 'Cart',
                    component: () => import('@/views/cart/Cart.vue'),
                    meta:{title:'购物车'}
                },
                {
                    path: '/SettleAccounts',
                    name: 'SettleAccounts',
                    component: () => import('@/views/cart/SettleAccounts.vue'),
                    meta:{title:'购物车-结算'}
                },
                {
                    path: '/vipLayout',
                    name: 'vipLayout',
                    component: () => import('@/views/vip/index.vue'),
                    children:[
                        {
                            path: '/vip',
                            name: '1personalInfo',
                            component: () => import('@/views/vip/pages/1profile/1personalInfo.vue'),
                            meta:{title:'个人信息'}
                        },
                        {
                            path: '/addressForGoods',
                            name: 'addressForGoods',
                            component: () => import('@/views/vip/pages/1profile/2addressForGoods.vue'),
                            meta:{title:'收货信息管理'}
                        },
                        {
                            path: '/addressForBill',
                            name: 'addressForBill',
                            component: () => import('@/views/vip/pages/1profile/3addressForBill.vue'),
                            meta:{title:'收票信息管理'}
                        },
                        {
                            path: '/billInfo',
                            name: 'billInfo',
                            component: () => import('@/views/vip/pages/1profile/4billInfo.vue'),
                            meta:{title:'发票信息管理'}
                        },
                        {
                            path: '/password',
                            name: 'password',
                            component: () => import('@/views/vip/pages/1profile/5password.vue'),
                            meta:{title:'账号密码管理'}
                        },
                        {
                            path: '/myIntegral',
                            name: 'myIntegral',
                            component: () => import('@/views/vip/pages/4integral/1mine.vue'),
                            meta:{title:'我的积分'}
                        },
                        {
                            path: '/myExchange',
                            name: 'myExchange',
                            component: () => import('@/views/vip/pages/4integral/2exchange.vue'),
                            meta:{title:'兑换明细'}
                        },
                        {
                            path: '/myHistory',
                            name: 'myHistory',
                            component: () => import('@/views/vip/pages/4integral/3history.vue'),
                            meta:{title:'积分明细'}
                        },
                        {
                            path: '/myOrderForGoods',
                            name: 'myOrderForGoods',
                            component: () => import('@/views/vip/pages/2order/1orderForGoods.vue'),
                            meta:{title:'我的订单'}
                        },
                        {
                            path: '/goodsDeliveryInfo',
                            name: 'goodsDeliveryInfo',
                            component: () => import('@/views/vip/pages/2order/goodsDeliveryInfo.vue'),
                            meta:{title:'我的订单-发货详情'}
                        },
                        {
                            path: '/goodsOrderDetail',
                            name: 'goodsOrderDetail',
                            component: () => import('@/views/vip/pages/2order/goodsOrderDetail.vue'),
                            meta:{title:'我的订单-详情'}
                        },
                        {
                            path: '/orderForBill',
                            name: '2orderForBill',
                            component: () => import('@/views/vip/pages/2order/2orderForBill.vue'),
                            meta:{title:'积分订单'}
                        },
                        {
                            path: '/billDeliveryInfo',
                            name: 'billDeliveryInfo',
                            component: () => import('@/views/vip/pages/2order/billDeliveryInfo.vue'),
                            meta:{title:'积分订单-发货详情'}
                        },
                        {
                            path: '/billOrderDetail',
                            name: 'billOrderDetail',
                            component: () => import('@/views/vip/pages/2order/billOrderDetail.vue'),
                            meta:{title:'积分订单-详情'}
                        },
                        {
                            path: '/Message',
                            name: 'Message',
                            component: () => import('@/views/vip/pages/5message/list.vue'),
                            meta:{title:'站内通知'}
                        },
                        {
                            path: '/MessageDetail',
                            name: 'MessageDetail',
                            component: () => import('@/views/vip/pages/5message/detail.vue'),
                            meta:{title:'站内通知-详情'}
                        },
                        {
                            path: '/balance',
                            name: 'balance',
                            component: () => import('@/views/vip/pages/3balance/balance.vue'),
                            meta:{title:'我的余额'}
                        },
                    ]
                },
                {
                    path: '/helpLayout',
                    name: 'helpLayout',
                    component: () => import('@/views/help/index.vue'),
                    children:[
                        {
                            path: '/help/registerAndLogin',
                            name: 'registerAndLogin',
                            component: () => import('@/views/help/pages/1registerAndLogin.vue'),
                            meta:{title:'注册与登录'}
                        },
                        {
                            path: '/help/registerAndLogin',
                            name: 'registerAndLogin',
                            component: () => import('@/views/help/pages/1registerAndLogin.vue'),
                            meta:{title:'注册与登录'}
                        },
                        {
                            path: '/help/goodsAndOrder',
                            name: 'goodsAndOrder',
                            component: () => import('@/views/help/pages/2goodsAndOrder.vue'),
                            meta:{title:'商品与订单'}
                        },
                        {
                            path: '/help/service',
                            name: 'service',
                            component: () => import('@/views/help/pages/3service.vue'),
                            meta:{title:'客户服务'}
                        },
                        {
                            path: '/help/terms',
                            name: 'terms',
                            component: () => import('@/views/help/pages/4terms.vue'),
                            meta:{title:'交易条款'}
                        },
                        {
                            path: '/help/payAndBill',
                            name: 'payAndBill',
                            component: () => import('@/views/help/pages/5payAndBill.vue'),
                            meta:{title:'支付与发票'}
                        }
                    ]
                },
                {
                    path: '/afterCareLayout',
                    name: 'afterCareLayout',
                    component: () => import('@/views/afterCare/index.vue'),
                    children:[
                        {
                            path: '/afterCare/afterCarePolicy',
                            name: 'afterCarePolicy',
                            component: () => import('@/views/afterCare/pages/1afterCarePolicy.vue'),
                            meta:{title:'售后政策'}
                        },
                        {
                            path: '/afterCare/PriceProtection',
                            name: 'PriceProtection',
                            component: () => import('@/views/afterCare/pages/2PriceProtection.vue'),
                            meta:{title:'价格保护'}
                        },
                        {
                            path: '/afterCare/RefundInstructions',
                            name: 'RefundInstructions',
                            component: () => import('@/views/afterCare/pages/3RefundInstructions.vue'),
                            meta:{title:'退款说明'}
                        },
                        {
                            path: '/afterCare/Repair',
                            name: 'Repair',
                            component: () => import('@/views/afterCare/pages/4Repair.vue'),
                            meta:{title:'返修/退换货'}
                        },
                        {
                            path: '/afterCare/Cancel',
                            name: 'Cancel',
                            component: () => import('@/views/afterCare/pages/5Cancel.vue'),
                            meta:{title:'取消订单'}
                        }
                    ]
                },
                {
                    path: '/afterCareLayout1',
                    name: 'afterCareLayout1',
                    component: () => import('@/views/afterCare1/index.vue'),
                    children:[
                        {
                            path: '/afterCare1/peisongSM',
                            name: 'peisongSM',
                            component: () => import('@/views/afterCare1/pages/peisongSM.vue'),
                            meta:{title:'配送说明'}
                        },
                    ]
                },
                {
                    path: '/customerServiceLayout',
                    name: 'customerServiceLayout',
                    component: () => import('@/views/customerService/index.vue'),
                    children:[
                        {
                            path: '/customerService/largePackaging',
                            name: 'largePackaging',
                            component: () => import('@/views/customerService/pages/1largePackaging.vue'),
                            meta:{title:'大包装订购与询价'}
                        },
                        {
                            path: '/customerService/quickOrdering',
                            name: 'quickOrdering',
                            component: () => import('@/views/customerService/pages/2quickOrdering.vue'),
                            meta:{title:'快速订购'}
                        },
                    ]
                },
            ]
        },
    ]
})
